import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["titleWidth", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { getLength } from 'utils/ui';
import { jsx as _jsx } from "react/jsx-runtime";
var DescriptionListWrapper = styled(Box).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'titleWidth';
  }
}).withConfig({
  displayName: "DescriptionList__DescriptionListWrapper",
  componentId: "sc-114a8gy-0"
})(["display:grid;grid-template-columns:fit-content(", ") minmax( 0,1fr );justify-items:start;gap:", " ", ";"], function (p) {
  return getLength(p.titleWidth);
}, function (p) {
  return p.theme.globals.spacing.xxs;
}, function (p) {
  return p.theme.globals.spacing.s;
});
export default function DescriptionList(_ref) {
  var _ref$titleWidth = _ref.titleWidth,
    titleWidth = _ref$titleWidth === void 0 ? '50%' : _ref$titleWidth,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(DescriptionListWrapper, _objectSpread(_objectSpread({
    titleWidth: titleWidth
  }, otherProps), {}, {
    as: "dl",
    children: children
  }));
}